import React, { useState } from "react";
import { PageHeader } from "../../components/Shell";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";

export default function MemberProfile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.patch("/me", { name, phone });
      setUser(data);
      toast.success("Profile updated");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="member-profile-page">
      <PageHeader eyebrow="Member" title="Profile" />

      <form onSubmit={save} className="max-w-xl border border-[#D2D8D4] rounded-md bg-white p-6 space-y-4">
        <Field label="Member ID">
          <input value={user?.member_code || "—"} disabled
            className="w-full px-3 py-2 border border-[#D2D8D4] rounded-md bg-zinc-50 mono font-bold text-[#05126E]" data-testid="profile-member-code" />
        </Field>
        <Field label="Name">
          <input value={name} onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 border border-[#D2D8D4] rounded-md" data-testid="profile-name" required />
        </Field>
        <Field label="Email">
          <input value={user?.email || ""} disabled
            className="w-full px-3 py-2 border-2 border-[#E4E4E7] bg-zinc-50 mono text-zinc-600" />
        </Field>
        <Field label="Phone">
          <input value={phone} onChange={(e) => setPhone(e.target.value)}
            className="w-full px-3 py-2 border border-[#D2D8D4] rounded-md" data-testid="profile-phone" />
        </Field>
        <button type="submit" disabled={busy}
          className="px-5 py-2.5 rounded-md bg-[#05126E] text-white font-semibold hover:bg-[#030B45] disabled:opacity-50 transition-colors"
          data-testid="profile-save">
          Save
        </button>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs font-bold uppercase tracking-widest">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}
